import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { NavbarComponent } from "../../components/navbar/navbar.component";

@Component({
    selector: "app-base-layout",
    templateUrl: "./base-layout.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NavbarComponent, RouterOutlet]
})
export class BaseLayoutComponent {}
